module.exports = __webpack_public_path__ + "static/printer-cycle-1db70d04bac852c5af8ba68027951c2c.svg";